var _style, _rect, _rect2, _rect3, _path, _polygon, _polygon2, _rect4, _rect5, _polygon3, _polygon4, _rect6, _rect7, _polygon5, _polygon6, _rect8, _rect9, _polygon7, _polygon8, _rect10, _rect11, _polygon9, _polygon10, _rect12, _rect13, _polygon11, _polygon12, _rect14, _rect15, _polygon13, _polygon14, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _path2, _polygon15, _polygon16, _rect22, _rect23, _polygon17, _polygon18, _rect24, _rect25, _polygon19, _polygon20, _rect26, _rect27, _polygon21, _polygon22, _rect28, _rect29, _polygon23, _polygon24, _rect30, _rect31, _polygon25, _polygon26, _rect32, _rect33, _polygon27, _polygon28, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _path3, _path4, _polygon29, _polygon30, _rect41, _rect42, _rect43, _polygon31, _polygon32, _rect44, _rect45, _polygon33, _polygon34, _rect46, _rect47, _polygon35, _polygon36, _rect48, _polygon37, _polygon38, _rect49, _rect50, _polygon39, _polygon40, _rect51, _rect52, _rect53, _polygon41, _polygon42, _rect54, _rect55, _polygon43, _polygon44, _rect56, _rect57, _polygon45, _polygon46, _rect58, _rect59, _rect60, _polygon47, _polygon48, _rect61, _rect62, _polygon49, _polygon50, _rect63, _rect64, _polygon51, _polygon52, _rect65, _polygon53, _polygon54, _rect66, _rect67, _polygon55, _polygon56, _rect68, _polygon57, _polygon58, _rect69, _rect70, _polygon59, _polygon60, _rect71, _rect72, _rect73, _polygon61, _polygon62, _rect74, _rect75, _polygon63, _polygon64, _rect76, _rect77, _polygon65, _polygon66, _rect78, _polygon67, _polygon68, _rect79, _rect80, _rect81, _rect82, _rect83, _path5, _rect84, _path6, _circle, _circle2, _circle3, _circle4, _polygon69, _polygon70, _rect85, _rect86, _path7, _path8, _polygon71, _polygon72, _polygon73, _path9, _path10, _path11, _path12, _path13, _path14, _rect87, _rect88, _rect89, _rect90;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerkehrsrechtGeschwindigkeitsverstossV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 920.4 560.8",
    style: {
      enableBackground: "new 0 0 920.4 560.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#3F3D56;}\n\t.st2{fill:#CCCCCC;}\n\t.st3{fill:#137F7B;}\n\t.st4{fill:#E6E6E6;}\n\t.st5{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.2,
    y: 392.4,
    className: "st0",
    width: 163,
    height: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 453.2,
    y: 392.4,
    className: "st0",
    width: 163,
    height: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 704.2,
    y: 392.4,
    className: "st0",
    width: 163,
    height: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M868.2,301.5c-1.5,0.8-2.9,1.7-4.1,2.9c-1.3-1.1-2.7-2.1-4.2-2.9c-1.5,0.8-2.9,1.7-4.1,2.9 c-1.3-1.1-2.7-2.1-4.2-2.9c0,0-6.5,3.2-6.5,7.1c0,0.1,0,0.2,0,0.3c0.2,2.6,6.9,3.2,10.6,2c2.7,0.8,5.6,0.8,8.4,0 c3.7,1.2,10.5,0.5,10.7-2.1c0-0.1,0-0.2,0-0.3C874.7,304.7,868.2,301.5,868.2,301.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7,167.1 1.2,162.5 33.5,133.7 115.4,133.7 115.4,159 62.3,194.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "130.3,149.8 130.3,134.2 119.5,134.2 119.5,138.1 115.4,133.7 88.9,162.5 78.5,169.4 62.4,287  86.7,311.3 143.1,311.3 143.1,163.6 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 162.5,
    className: "st0",
    width: 87.7,
    height: 148.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 275,
    className: "st2",
    width: 16.1,
    height: 36.3
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17.9,285.3 17.9,279.6 11,279.6 11,285.3 17.4,285.3 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17.4,290 11,290 11,295.7 17.9,295.7 17.9,290 "
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 279.6,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 290,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.2,285.3 65.2,279.6 58.3,279.6 58.3,285.3 64.6,285.3 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64.6,290 58.3,290 58.3,295.7 65.2,295.7 65.2,290 "
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 69.8,
    y: 279.6,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 69.8,
    y: 290,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.7,170 113.7,164.2 106.7,164.2 106.7,170 113.1,170 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.1,174.6 106.7,174.6 106.7,180.4 113.7,180.4 113.7,174.6 "
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 118.3,
    y: 164.2,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 118.3,
    y: 174.6,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.7,202.3 113.7,196.5 106.7,196.5 106.7,202.3 113.1,202.3 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.1,206.9 106.7,206.9 106.7,212.7 113.7,212.7 113.7,206.9 "
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 118.3,
    y: 196.5,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 118.3,
    y: 206.9,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.7,234.6 113.7,228.8 106.7,228.8 106.7,234.6 113.1,234.6 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.1,239.2 106.7,239.2 106.7,245 113.7,245 113.7,239.2 "
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 118.3,
    y: 228.8,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 118.3,
    y: 239.2,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.7,266.9 113.7,261.1 106.7,261.1 106.7,266.9 113.1,266.9 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.1,271.5 106.7,271.5 106.7,277.3 113.7,277.3 113.7,271.5 "
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 118.3,
    y: 261.1,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 118.3,
    y: 271.5,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 170,
    className: "st1",
    width: 66.9,
    height: 13.8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 197.7,
    className: "st1",
    width: 66.9,
    height: 13.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 225.4,
    className: "st1",
    width: 66.9,
    height: 13.8
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 253,
    className: "st1",
    width: 66.9,
    height: 13.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M138.2,302.4c-1.5,0.8-2.9,1.7-4.1,2.9c-1.3-1.1-2.7-2.1-4.2-2.9c-1.5,0.8-2.9,1.7-4.1,2.9 c-1.3-1.1-2.7-2.1-4.2-2.9c0,0-6.5,3.2-6.5,7.1c0,0.1,0,0.2,0,0.3c0.2,2.6,6.9,3.2,10.6,2c2.7,0.8,5.6,0.8,8.4,0 c3.7,1.2,10.5,0.5,10.7-2.1c0-0.1,0-0.2,0-0.3C144.7,305.5,138.2,302.4,138.2,302.4z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "108.2,167.1 102.4,162.5 134.7,133.7 216.6,133.7 216.6,159 163.5,194.8 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "231.5,149.8 231.5,134.2 220.7,134.2 220.7,138.1 216.6,133.7 190.1,162.5 179.7,169.4 163.6,287  187.9,311.3 244.3,311.3 244.3,163.6 "
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 102.4,
    y: 162.5,
    className: "st0",
    width: 87.7,
    height: 148.8
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 136.4,
    y: 275,
    className: "st2",
    width: 16.1,
    height: 36.3
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "119.1,285.3 119.1,279.6 112.2,279.6 112.2,285.3 118.6,285.3 "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "118.6,290 112.2,290 112.2,295.7 119.1,295.7 119.1,290 "
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 123.7,
    y: 279.6,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 123.7,
    y: 290,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "166.4,285.3 166.4,279.6 159.5,279.6 159.5,285.3 165.9,285.3 "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "165.9,290 159.5,290 159.5,295.7 166.4,295.7 166.4,290 "
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 279.6,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 290,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.9,170 214.9,164.2 208,164.2 208,170 214.3,170 "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.3,174.6 208,174.6 208,180.4 214.9,180.4 214.9,174.6 "
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 164.2,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 174.6,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.9,202.3 214.9,196.5 208,196.5 208,202.3 214.3,202.3 "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.3,206.9 208,206.9 208,212.7 214.9,212.7 214.9,206.9 "
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 196.5,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 206.9,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.9,234.6 214.9,228.8 208,228.8 208,234.6 214.3,234.6 "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.3,239.2 208,239.2 208,245 214.9,245 214.9,239.2 "
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 228.8,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 239.2,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.9,266.9 214.9,261.1 208,261.1 208,266.9 214.3,266.9 "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.3,271.5 208,271.5 208,277.3 214.9,277.3 214.9,271.5 "
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 261.1,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 271.5,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 112.2,
    y: 170,
    className: "st1",
    width: 66.9,
    height: 13.8
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 112.2,
    y: 197.7,
    className: "st1",
    width: 66.9,
    height: 13.8
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 112.2,
    y: 225.4,
    className: "st1",
    width: 66.9,
    height: 13.8
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 112.2,
    y: 253,
    className: "st1",
    width: 66.9,
    height: 13.8
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 200.4,
    className: "st1",
    width: 2.8,
    height: 110.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.6,232.6c0,1.2,0,2.4,0,3.6c-1,43.4-53.1,43.7-54.5,0.3c0-1.2-0.1-2.4-0.1-3.6c-0.2-48.5,26.9-88,26.9-88 S332.3,184,332.6,232.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.6,302.1c-1.5,0.8-2.9,1.7-4.1,2.9c-1.3-1.1-2.7-2.1-4.2-2.9c-1.5,0.8-2.9,1.7-4.1,2.9 c-1.3-1.1-2.7-2.1-4.2-2.9c0,0-6.5,3.2-6.5,7.1c0,0.1,0,0.2,0,0.3c0.2,2.6,6.9,3.2,10.6,2c2.7,0.8,5.6,0.8,8.4,0 c3.7,1.2,10.5,0.5,10.7-2.1c0-0.1,0-0.2,0-0.3C302.1,305.2,295.6,302.1,295.6,302.1z"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "373.7,264 370.3,258.2 402.6,205.5 485.6,205.5 485.6,213.5 455.6,270.9 421,277.8 "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "499.9,246.8 499.9,203.7 489,203.7 489,209.3 485.6,205.5 457.9,258.2 453.3,262.8 447.6,285.9  457.9,311.3 511,311.3 511,259.4 "
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 370.3,
    y: 258.2,
    className: "st0",
    width: 87.7,
    height: 53.1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 427.4,
    y: 275,
    className: "st1",
    width: 18.5,
    height: 16.1
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 403.7,
    y: 274.4,
    className: "st2",
    width: 16.1,
    height: 36.9
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "385.3,280.1 385.3,274.4 378.4,274.4 378.4,280.1 384.7,280.1 "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384.7,284.8 378.4,284.8 378.4,290.5 385.3,290.5 385.3,284.8 "
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 274.4,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 284.8,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "482.7,281.6 482.7,275.8 475.8,275.8 475.8,281.6 482.2,281.6 "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "482.2,286.2 475.8,286.2 475.8,291.9 482.7,291.9 482.7,286.2 "
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 487.4,
    y: 275.8,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 487.4,
    y: 286.2,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "410,227.1 409.1,225.6 417.6,211.7 439.5,211.7 439.5,213.9 431.6,229 422.5,230.8 "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "439.5,211.7 432.2,225.6 431,226.8 429.5,232.9 432.2,239.6 446.2,239.6 446.2,225.9 "
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 409.1,
    y: 225.6,
    className: "st0",
    width: 23.1,
    height: 14
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "418.9,231.6 418.9,228.9 415.6,228.9 415.6,231.6 418.6,231.6 "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "418.6,233.9 415.6,233.9 415.6,236.6 418.9,236.6 418.9,233.9 "
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 421.1,
    y: 228.9,
    className: "st1",
    width: 3.3,
    height: 2.8
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 421.1,
    y: 233.8,
    className: "st1",
    width: 3.3,
    height: 2.8
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "478.3,264 474.8,258.2 507.1,205.5 590.2,205.5 590.2,213.5 560.2,270.9 525.6,277.8 "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "604.5,246.8 604.5,203.7 593.6,203.7 593.6,209.3 590.2,205.5 562.5,258.2 557.9,262.8 552.1,285.9  562.5,311.3 615.6,311.3 615.6,259.4 "
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 474.8,
    y: 258.2,
    className: "st0",
    width: 87.7,
    height: 53.1
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 531.9,
    y: 275,
    className: "st1",
    width: 18.5,
    height: 16.1
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 274.4,
    className: "st2",
    width: 16.1,
    height: 36.9
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.8,280.1 489.8,274.4 482.9,274.4 482.9,280.1 489.2,280.1 "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.2,284.8 482.9,284.8 482.9,290.5 489.8,290.5 489.8,284.8 "
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 494.4,
    y: 274.4,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 494.4,
    y: 284.8,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "587.3,280.7 587.3,275 580.4,275 580.4,280.7 586.7,280.7 "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "586.7,285.3 580.4,285.3 580.4,291.1 587.3,291.1 587.3,285.3 "
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 591.9,
    y: 275,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 591.9,
    y: 285.3,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "579.5,264 576,258.2 608.3,205.5 691.4,205.5 691.4,213.5 661.4,270.9 626.8,277.8 "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "705.7,246.8 705.7,203.7 694.8,203.7 694.8,209.3 691.4,205.5 663.7,258.2 659.1,262.8 653.3,285.9  663.7,311.3 716.8,311.3 716.8,259.4 "
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 258.2,
    className: "st0",
    width: 87.7,
    height: 53.1
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 633.1,
    y: 275,
    className: "st1",
    width: 18.5,
    height: 16.1
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 609.5,
    y: 274.4,
    className: "st2",
    width: 16.1,
    height: 36.9
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "591,280.1 591,274.4 584.1,274.4 584.1,280.1 590.5,280.1 "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "590.5,284.8 584.1,284.8 584.1,290.5 591,290.5 591,284.8 "
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 595.6,
    y: 274.4,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 595.6,
    y: 284.8,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "688.5,280.7 688.5,275 681.6,275 681.6,280.7 687.9,280.7 "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "687.9,285.3 681.6,285.3 681.6,291.1 688.5,291.1 688.5,285.3 "
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 693.1,
    y: 275,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 693.1,
    y: 285.3,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "512.1,228 511.2,226.5 519.7,212.6 541.5,212.6 541.5,214.7 533.6,229.8 524.5,231.6 "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "541.5,212.6 534.2,226.5 533,227.7 531.5,233.8 534.2,240.4 548.2,240.4 548.2,226.8 "
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 511.2,
    y: 226.5,
    className: "st0",
    width: 23.1,
    height: 14
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "520.9,232.5 520.9,229.7 517.6,229.7 517.6,232.5 520.7,232.5 "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "520.7,234.7 517.6,234.7 517.6,237.4 520.9,237.4 520.9,234.7 "
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 523.1,
    y: 229.7,
    className: "st1",
    width: 3.3,
    height: 2.8
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 523.1,
    y: 234.7,
    className: "st1",
    width: 3.3,
    height: 2.8
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "614.1,227.1 613.2,225.6 621.7,211.7 643.6,211.7 643.6,213.9 635.7,229 626.6,230.8 "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "643.6,211.7 636.3,225.6 635.1,226.8 633.5,232.9 636.3,239.6 650.2,239.6 650.2,225.9 "
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 613.2,
    y: 225.6,
    className: "st0",
    width: 23.1,
    height: 14
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "623,231.6 623,228.9 619.7,228.9 619.7,231.6 622.7,231.6 "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "622.7,233.9 619.7,233.9 619.7,236.6 623,236.6 623,233.9 "
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 625.2,
    y: 228.9,
    className: "st1",
    width: 3.3,
    height: 2.8
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 625.2,
    y: 233.8,
    className: "st1",
    width: 3.3,
    height: 2.8
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "684,264 680.6,258.2 712.9,205.5 795.9,205.5 795.9,213.5 765.9,270.9 731.3,277.8 "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "810.2,212.9 810.2,203.7 799.4,203.7 799.4,209.3 795.9,205.5 768.2,258.2 763.6,262.8 757.9,285.9  768.2,311.3 821.3,311.3 821.3,259.4 "
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 680.6,
    y: 258.2,
    className: "st0",
    width: 87.7,
    height: 53.1
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 737.7,
    y: 275,
    className: "st1",
    width: 18.5,
    height: 16.1
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 714,
    y: 274.4,
    className: "st2",
    width: 16.1,
    height: 36.9
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "695.6,280.1 695.6,274.4 688.7,274.4 688.7,280.1 695,280.1 "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "695,284.8 688.7,284.8 688.7,290.5 695.6,290.5 695.6,284.8 "
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 700.2,
    y: 274.4,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 700.2,
    y: 284.8,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "793,280.7 793,275 786.1,275 786.1,280.7 792.5,280.7 "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "792.5,285.3 786.1,285.3 786.1,291.1 793,291.1 793,285.3 "
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 797.7,
    y: 275,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 797.7,
    y: 285.3,
    className: "st1",
    width: 6.9,
    height: 5.8
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "716.2,228 715.2,226.5 723.7,212.6 745.6,212.6 745.6,214.7 737.7,229.8 728.6,231.6 "
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "745.6,212.6 738.3,226.5 737.1,227.7 735.6,233.8 738.3,240.4 752.3,240.4 752.3,226.8 "
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 715.2,
    y: 226.5,
    className: "st0",
    width: 23.1,
    height: 14
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "725,232.5 725,229.7 721.7,229.7 721.7,232.5 724.7,232.5 "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "724.7,234.7 721.7,234.7 721.7,237.4 725,237.4 725,234.7 "
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 727.2,
    y: 229.7,
    className: "st1",
    width: 3.3,
    height: 2.8
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 727.2,
    y: 234.7,
    className: "st1",
    width: 3.3,
    height: 2.8
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 310.7,
    className: "st1",
    width: 919.6,
    height: 1.7
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    y: 467.1,
    className: "st1",
    width: 919.6,
    height: 1.7
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 857.5,
    y: 200.4,
    className: "st1",
    width: 2.8,
    height: 110.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M887.5,232.5c0,1.2,0,2.4,0,3.6c-1,43.4-53,43.7-54.5,0.3c0-1.2-0.1-2.4-0.1-3.6c-0.2-48.5,26.9-88,26.9-88 S887.3,184,887.5,232.5z"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 278.1,
    y: 418.7,
    className: "st1",
    width: 29.4,
    height: 4.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M520.3,419.8l-6.1,1.4l-230.8,0.1l-2.1-4.8c-3.6-8.3-4.9-17.4-3.6-26.4c1-6.7,3.5-13.3,9.1-16.2l10.2-68.2 l127.7-0.2l49.4,39.8c0,0,23.3-0.4,36,15.3c4,5,6.9,11.6,7.7,20.4l0.5,8.2L520.3,419.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 469.6,
    cy: 418.6,
    r: 28.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 469.6,
    cy: 418.6,
    r: 15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 329,
    cy: 418.7,
    r: 28.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 329,
    cy: 418.7,
    r: 15
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "454.6,340.6 385.7,340.7 377.2,340.7 363,340.7 363,339.6 363,327.1 363,313.1 372.5,313.1  380.9,313.1 395.8,313.1 404.2,313.1 421.4,313.1 "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "351.8,340.7 315.4,340.7 315.4,333.6 315.4,321.1 315.4,313.1 320.7,313.1 329.1,313.1 351.8,313.1 "
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 363,
    y: 361.2,
    className: "st1",
    width: 4.7,
    height: 8.9
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 435.9,
    y: 348.6,
    className: "st1",
    width: 8.9,
    height: 4.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.2,331.1h0.5c5.4,0,9.8,4.4,9.8,9.8l0,0c0,5.4-4.4,9.8-9.8,9.8h-0.5l0,0V331.1L439.2,331.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M518.4,389.2c-8.3,0.9-15.7-5.1-16.6-13.4c-0.7-6.3,2.7-12.4,8.4-15.2c4,5,6.9,11.6,7.7,20.4L518.4,389.2z"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "380.9,313.1 363,339.6 363,327.1 372.5,313.1 "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "329.1,313.1 315.4,333.6 315.4,321.1 320.7,313.1 "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "404.2,313.1 385.7,340.7 377.2,340.7 395.8,313.1 "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139,536.3c0,0-4.6,10.1-8.4,12.9c-3.8-2.8-8.5-12.9-8.5-12.9s-4.6,10.1-8.4,12.9c-3.8-2.8-8.5-12.9-8.5-12.9 S92,549.7,92.1,556.1c0,0.2,0,0.3,0,0.5c0.4,4.2,14,5.2,21.5,3.3c5.6,1.3,11.3,1.3,16.9,0c7.4,2,21.3,0.9,21.7-3.4 c0-0.2,0-0.3,0-0.5C152.2,549.6,139,536.3,139,536.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M415.3,536.3c0,0-4.6,10.1-8.4,12.9c-3.8-2.8-8.5-12.9-8.5-12.9s-4.6,10.1-8.4,12.9c-3.8-2.8-8.5-12.9-8.5-12.9 s-13.1,13.4-13.1,19.8c0,0.2,0,0.3,0,0.5c0.4,4.2,14,5.2,21.5,3.3c5.6,1.3,11.3,1.3,16.9,0c7.4,2,21.3,0.9,21.7-3.4 c0-0.2,0-0.3,0-0.5C428.5,549.6,415.3,536.3,415.3,536.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M689.7,536.3c0,0-4.6,10.1-8.4,12.9c-3.8-2.8-8.5-12.9-8.5-12.9s-4.6,10.1-8.4,12.9c-3.8-2.8-8.5-12.9-8.5-12.9 s-13.1,13.4-13.1,19.8c0,0.2,0,0.3,0,0.5c0.4,4.2,14,5.2,21.5,3.3c5.6,1.3,11.3,1.3,16.9,0c7.4,2,21.3,0.9,21.7-3.4 c0-0.2,0-0.3,0-0.5C702.9,549.6,689.7,536.3,689.7,536.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M155.6,47.3l-0.1,0.1c-2.7,1.5-5.9,1.5-8.5,0c-0.1,0-0.2-0.1-0.2-0.1c-2.7-1.4-5.9-1.4-8.5,0l-0.1,0.1 c-2.7,1.5-5.9,1.5-8.5,0c-0.1,0-0.2-0.1-0.2-0.1c-2.6-1.4-5.8-1.4-8.5,0c-4,2.1-9.3,5.8-9.3,9.9c0,0.2,0,0.3,0,0.5 C112,62,126,63.1,133.7,61c5.7,1.3,11.7,1.3,17.4,0c7.7,2.1,21.9,0.9,22.4-3.5c0-0.2,0-0.3,0-0.5c0-4.1-5.4-7.8-9.4-9.9 C161.4,45.8,158.2,45.9,155.6,47.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M415.7,92.6l-0.1,0.1c-2.7,1.5-5.9,1.5-8.5,0c-0.1,0-0.2-0.1-0.2-0.1c-2.7-1.4-5.9-1.4-8.5,0l-0.1,0.1 c-2.7,1.5-5.9,1.5-8.5,0c-0.1,0-0.2-0.1-0.2-0.1c-2.6-1.4-5.8-1.4-8.5,0c-4,2.1-9.3,5.8-9.3,9.9c0,0.2,0,0.3,0,0.5 c0.5,4.3,14.5,5.4,22.1,3.4c5.7,1.3,11.7,1.3,17.4,0c7.7,2.1,21.9,0.9,22.4-3.5c0-0.2,0-0.3,0-0.5c0-4.1-5.4-7.8-9.4-9.9 C421.5,91.2,418.4,91.2,415.7,92.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M595.5,49.3l-0.1,0.1c-2.7,1.5-5.9,1.5-8.5,0c-0.1,0-0.2-0.1-0.2-0.1c-2.7-1.4-5.9-1.4-8.5,0l-0.1,0.1 c-2.7,1.5-5.9,1.5-8.5,0c-0.1,0-0.2-0.1-0.2-0.1c-2.6-1.4-5.8-1.4-8.5,0c-4,2.1-9.3,5.8-9.3,9.9c0,0.2,0,0.3,0,0.5 c0.5,4.3,14.5,5.4,22.1,3.4c5.7,1.3,11.7,1.3,17.4,0c7.7,2.1,21.9,0.9,22.4-3.5c0-0.2,0-0.3,0-0.5c0-4.1-5.4-7.8-9.4-9.9 C601.3,47.8,598.1,47.8,595.5,49.3z"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    y: 559.1,
    className: "st1",
    width: 919.6,
    height: 1.7
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 330.5,
    className: "st3",
    width: 114.4,
    height: 6
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 203.9,
    y: 344.5,
    className: "st3",
    width: 77.5,
    height: 6
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 224.8,
    y: 359.5,
    className: "st3",
    width: 50.1,
    height: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkehrsrechtGeschwindigkeitsverstossV2);
export default __webpack_public_path__ + "static/media/Verkehrsrecht_Geschwindigkeitsverstoss_v2.2428154a8d8666fe9b7bc2573ff23bbc.svg";
export { ForwardRef as ReactComponent };